import React, { Component } from "react";

import { Segment, Accordion, Header, Icon, Image, List } from "semantic-ui-react";

class MetaPanel extends Component {
    state = { activeIndex: 0 };

    setActiveIndex = (e, titleProps) => {
        const { index } = titleProps;
        const { activeIndex } = this.state;

        let newIndex = activeIndex === index ? -1 : index;

        this.setState({ activeIndex: newIndex });
    };

    countUserPosts = userPosts => {
        if (!userPosts.length) return "No Users Posted Yet!";

        return userPosts.map(({ name, avatar, count }, idx) => (
            <List.Item key={idx}>
                <Image src={avatar} avatar />

                <List.Content>
                    <List.Header as="a">{name}</List.Header>
                    <List.Description>{`${count} ${count > 1 ? "posts" : "post"}`}</List.Description>
                </List.Content>
            </List.Item>
        ));
    };

    render() {
        const { activeIndex } = this.state;
        const { currentChannel, isPrivateChannel, userPosts } = this.props.channels;

        if (isPrivateChannel) return null;

        return (
            <Segment className="meta-panel">
                <Header as="h4" attached="top">
                    About # <span className="channel-name">{currentChannel?.channelName}</span> channel
                </Header>

                <Accordion styled attached="true">
                    <Accordion.Title active={activeIndex === 0} index={0} onClick={this.setActiveIndex}>
                        <Icon name="dropdown" />
                        <Icon name="info" />
                        channel details
                    </Accordion.Title>

                    <Accordion.Content active={activeIndex === 0}>{currentChannel?.channelDetails}</Accordion.Content>

                    <Accordion.Title active={activeIndex === 1} index={1} onClick={this.setActiveIndex}>
                        <Icon name="dropdown" />
                        <Icon name="user circle" />
                        top posters
                    </Accordion.Title>

                    <Accordion.Content active={activeIndex === 1}>
                        <List>{this.countUserPosts(userPosts)}</List>
                    </Accordion.Content>

                    <Accordion.Title active={activeIndex === 2} index={2} onClick={this.setActiveIndex}>
                        <Icon name="dropdown" />
                        <Icon name="pencil alternate" />
                        created by
                    </Accordion.Title>

                    <Accordion.Content active={activeIndex === 2}>
                        <Image src={currentChannel?.createdBy?.avatar} avatar />
                        <span className="creator-name">{currentChannel?.createdBy?.name}</span>
                    </Accordion.Content>
                </Accordion>
            </Segment>
        );
    }
}

export default MetaPanel;
